import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RuntimeConfigLoaderService } from 'runtime-config-loader';
import { BehaviorSubject } from 'rxjs';
import { SideMenu } from 'src/app/models';
import { Projeto } from 'src/app/types/projeto';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class SeletorProjetosService {
    public readonly apiPath = 'api/projetos/projetoslistaprojetos/';
    private seletorVisivel = new BehaviorSubject<boolean>(false);
    get seletorVisivel$() {
        return this.seletorVisivel.asObservable();
    }

    private _projeto = new BehaviorSubject<Projeto>(null);
    get projeto$() {
        return this._projeto.asObservable();
    }

    get projeto() {
        return this._projeto.value;
    }

    private featureFlags: any;

    constructor(
        private http: HttpClient,
        private _config: RuntimeConfigLoaderService
    ) {
        this.featureFlags = this._config.getConfigObjectKey('featureFlags');
    }

    public mostrarSeletor() {
        this.setProjeto(null);
        this.seletorVisivel.next(true);
    }

    public esconderSeletor() {
        this.seletorVisivel.next(false);
    }

    public setProjeto(projeto: Projeto) {
        this._projeto.next(projeto);
    }

    public fetchProjeto(idProjeto: number) {
        return this.http.get<Projeto>(`${this.apiPath}${idProjeto}/`);
    }

    public getAllFlags() {
        return this.featureFlags;
    }

    public isFeatureFlagEnabled(flag: string) {
        if (!environment.production) return true;

        return (
            this.featureFlags &&
            (this.featureFlags[flag] === undefined || this.featureFlags[flag])
        );
    }

    public filtraLinksDesabilitados(links: Array<SideMenu>) {
        return links.filter(el => {
            el.submenus = el.submenus.filter(item =>
                this.isFeatureFlagEnabled(item.id)
            );
            return this.isFeatureFlagEnabled(el.id);
        });
    }
}
